import React, { useEffect, useState } from 'react';
import { RefreshCw, X } from 'lucide-react';
import useVersionCheck from '../hooks/useVersionCheck';

const UpdateNotification = () => {
  const { updateAvailable, applyUpdate } = useVersionCheck();
  const [show, setShow] = useState(false);
  const [countdown, setCountdown] = useState(30);

  useEffect(() => {
    if (updateAvailable) {
      setShow(true);
      setCountdown(30);
    }
  }, [updateAvailable]);

  useEffect(() => {
    if (!show || !updateAvailable) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          // Auto-reload after countdown
          applyUpdate();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [show, updateAvailable, applyUpdate]);

  if (!show || !updateAvailable) return null;

  return (
    <div className="fixed top-4 right-4 z-[9999] animate-in slide-in-from-top duration-500">
      <div className="glass-card p-4 rounded-lg shadow-2xl border border-indigo-500/30 bg-gradient-to-r from-indigo-900/90 to-purple-900/90 backdrop-blur-xl max-w-md">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 mt-0.5">
            <div className="w-10 h-10 rounded-full bg-indigo-500/20 flex items-center justify-center animate-pulse">
              <RefreshCw className="text-indigo-400" size={20} />
            </div>
          </div>
          
          <div className="flex-1">
            <h3 className="text-white font-semibold text-sm mb-1 flex items-center gap-2">
              🎉 New Version Available!
            </h3>
            <p className="text-gray-300 text-xs mb-3">
              We've updated the app with new features and improvements.
            </p>
            
            <div className="flex items-center gap-2">
              <button
                onClick={applyUpdate}
                className="px-4 py-2 bg-indigo-600 hover:bg-indigo-500 text-white text-xs font-medium rounded-lg transition-colors duration-200 flex items-center gap-2"
              >
                <RefreshCw size={14} />
                Reload Now
              </button>
              
              <button
                onClick={() => setShow(false)}
                className="px-3 py-2 bg-gray-700/50 hover:bg-gray-600/50 text-gray-300 text-xs font-medium rounded-lg transition-colors duration-200"
              >
                Later
              </button>
              
              <span className="text-gray-400 text-xs ml-auto">
                Auto-reload in {countdown}s
              </span>
            </div>
          </div>
          
          <button
            onClick={() => setShow(false)}
            className="flex-shrink-0 text-gray-400 hover:text-white transition-colors"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;
